module.exports = __webpack_public_path__ + "img/VP-Classic_Overview-Spare_1.57cc3b00.jpg";